<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="700">
        <v-form class="mb-3" validate-on="input lazy" @submit.prevent="updateDeviceGroup">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4>Update Device Groups</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col class="py-0" cols="12" sm="12">
                            <v-select v-model="formData['device_group_ids']" :items="deviceGroups"
                                      :rules="[vRules.required]"
                                      density="compact" item-title="name" multiple item-value="id" label="Device Group">
                            </v-select>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive} from "vue";
import {send} from "@/composables/apiClient";
import {useLoadingStore} from "@/stores/loadingStore";
import {useSnackbarStore} from "@/stores/snackBarStore";

const {showSnackbar} = useSnackbarStore();
const loadingStore = useLoadingStore();
const props = defineProps({
    modelValue: Boolean,
    device: {
        type: Object
    },
    deviceGroups: {
        type: Array
    }
});


const formData = reactive({
    valid: false,
    device_group_ids: props.device.device_groups.map(group => group.id) ?? null,
});

const emits = defineEmits(['update:modelValue', 'updateDeviceGroup']);
const dialogSwitch = ref(props.modelValue);
const errors = ref([]);

const updateDeviceGroup = () => {
    errors.value = [];
    loadingStore.showLoading('Updating...', 'Please wait while we save your changes');
    send('post', `device/${props.device.id}/device-groups`, formData)
        .then((response) => {
            showSnackbar(response.data.message);
            if (response.data.success) {
                emits('updateDeviceGroup', response.data.data.device);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
        .finally(() => loadingStore.hideLoading());
}

</script>
